import React from 'react'

import {alpha, Box, Grid, Typography} from "@mui/material"
import {IconSeeker} from "@ui-seeker/core";
import { BIHeaders, BISubHeaders } from '../../@signals'


export default function pricesColumn(name, palette, idx) {

    return {
        name,
        setBodyRowProps: () => ({ sx:{ p: 0, backgroundColor: 'primary.main' } }),
        setBodyCellProps: () => ({ sx:{ p: 0, verticalAlign: 'top', userSelect: 'none', cursor: 'default', borderRight: idx === BIHeaders.value.length - 1 ? 0 : 2, borderColor: 'primary.main' } }),
        render: value => <PriceCell value={value} palette={palette} />

    }
}


function PriceCell({ value, palette }) {
    return <Box sx={{ p: 1, borderBottom: 2, borderColor: 'primary.main', minHeight: 42}}>
        <Grid container spacing={1} sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
            {value?.map(({price, isCheapest, isMoreExpensive, evolutionChange, evolutionDiff, noresult}, idx) => {
                if (noresult || !price) return <Grid key={`${price}-${idx}`} item xs={12 / BISubHeaders.value?.length} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <Typography sx={{textAlign: 'center', fontWeight: 'bold', width: '120px'}}>
                        N/A
                    </Typography>
                </Grid>
                return <Grid key={`${price}-${idx}`} item xs={12 / BISubHeaders.value?.length} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <Box sx={{
                        border: 2,
                        borderColor: isCheapest ? palette.success.main : isMoreExpensive ? palette.error.main : price === 'N/A' ? '' : palette.secondary.light,
                        backgroundColor: isCheapest ? alpha(palette.success.main, 0.1) : isMoreExpensive ? alpha(palette.error.main, 0.1) : price === 'N/A' ? '' : alpha(palette.secondary.lighter, 0.5),
                        display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 1, width: '120px'
                    }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Typography sx={{textAlign: 'center', fontWeight: 'bold'}}>
                                    {price}
                                </Typography>
                            </Grid>
                            {!!evolutionChange && evolutionDiff !== null && <Grid item xs={12} sx={{  height: 30 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, px: 2 }} >
                                    <IconSeeker
                                        icon={evolutionChange === "increase" ? "arrow-up" : evolutionChange === "decrease" ? "arrow-down" : "equals"}
                                        sx={{ color: evolutionChange === "increase" ? "success.dark" : evolutionChange === "decrease" ? "error.main" : "" }}
                                    />
                                    <Typography sx={{textAlign: 'center', fontSize: '.7rem'  }}>
                                        {evolutionDiff}%
                                    </Typography>
                                </Box>
                            </Grid>}
                        </Grid>
                    </Box>
                </Grid>
            })}
        </Grid>
    </Box>
}